// extracted by mini-css-extract-plugin
export default {"gallery-container":"Gallery_gallery-container__5ncBu","gallery-pic":"Gallery_gallery-pic__2Qag6"};